// @flow
import styled from "styled-components";

export const SpinnerContainer = styled.div`
    text-align: center;
    margin-top: 25px;
`;

export const Spacer = styled.div`
    height: 25px;
`;

export const Messages = styled.div``;

export const Header = styled.div`
    padding: 8px 0;
    border-bottom: 1px solid #ccc;
`;
export const Entry = styled.div`
    width: 100%;
    background-color: #fff;
    position: relative;
    text-align: left;
`;

export const Content = styled.div`
    padding: 16px;
`;
export const Title = styled.div`
    display: inline-block;
    font-style: italic;
    margin-left: 16px;
`;
export const Name = styled.div`
    font-weight: bold;
    display: inline;
`;
export const Text = styled.div`
    display: block;
    margin-top: 16px;
`;

export const Footer = styled.div`
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding: 0;
    text-align: left;
    position: relative;
    padding-bottom: 16px;
`;

export const DataCell = styled.div`
    display: inline-block;
    vertical-align: top;
    height: 24px;
    line-height: 24px;
    padding-left: 16px;
    padding-top: 16px;
`;

export const DataCellText = styled.div`
    display: inline-block;
    vertical-align: top;
    padding-left: 4px;
`;

export const Actions = styled.div`
    position: absolute;
    right: 16px;
    top: 16px;
    height: 24px;
`;

export const Action = styled.div`
    display: inline-block;
    padding-left: 4px;
`;

export const Icon = styled.div`
    color: #ccc;
    display: inline-block;
`;
export const Buttons = styled.div`
    height: 36px;
    text-align: right;
    & > button {
        margin-right: 20px;
    }
`;
export const SpinnerWrapper = styled.div``;

export const WriteMessagePlaceholder = styled.div`
    opacity: 0.5;
    font-style: italic;
    width: 100%;
    display: inline-block;
    cursor: text;
`;



// WEBPACK FOOTER //
// ./src/messages-page-view/styled.js